export default __webpack_public_path__ + "static/media/icone-mulheres-gestacao.e5fef067.svg";